export const PassengerNumbers = Object.freeze({
  ADULT: 'num-adults',
  CHILD: 'num-children',
  LAP_INFANT: 'num-infants',
})
